// Simplified-Chinese strings for the home area. Keys are the exact English source strings.
export const home: Record<string, string> = {
  // ── Dashboard ──────────────────────────────────────────────────────────────
  'Pinpoint — Home': 'Pinpoint — 首页',
  'Jump back in': '继续学习',
  'All videos →': '所有视频 →',
  'Nothing in progress yet — open a video and start taking timestamped notes.':
    '还没有进行中的内容 — 打开一个视频，开始记录带时间戳的笔记。',
  'Browse the library →': '浏览视频库 →',
  'Recently added': '最近添加',
  'View all →': '查看全部 →',
  'Recent notes': '最近笔记',
  'All notes →': '所有笔记 →',
  'No notes yet — take your first timestamped note on a video.':
    '还没有笔记 — 在视频上记录你的第一条带时间戳的笔记。',
  'Go to': '前往',
  'Library': '视频库',
  'Notes': '笔记',
  'Search': '搜索',
  'Resume at {time} · {pct}% watched': '从 {time} 继续 · 已观看 {pct}%',
  'Uploading…': '上传中…',
  'Processing…': '处理中…',
  '{count} note': '{count} 条笔记',
  '{count} notes': '{count} 条笔记',
  'Notes without a video': '无关联视频的笔记',
  'edited {ago}': '编辑于 {ago}',
  'Open': '打开',
  '+ {count} more': '还有 {count} 条',
  'Note': '笔记',
  'rich note': '富文本笔记',
  'range': '时间区间',
  'point': '时间点',
  'just now': '刚刚',
  '{n}m ago': '{n} 分钟前',
  '{n}h ago': '{n} 小时前',
  '{n}d ago': '{n} 天前',

  // ── Landing (marketing) ─────────────────────────────────────────────────────
  'Pinpoint': 'Pinpoint',
  'Pinpoint — note-taking for video learning': 'Pinpoint — 为视频学习而生的笔记工具',
  'Pin every moment worth learning.': '标记每一个值得学习的瞬间。',
  'Upload videos or paste a YouTube link, take timestamped notes, and study what matters — built for serious video learning.':
    '上传视频或粘贴 YouTube 链接，记录带时间戳的笔记，专注学习真正重要的内容 — 为认真的视频学习而打造。',
  'Get started': '开始使用',
  '{host} to enter': '访问 {host} 进入',
  'landing · apex host': 'landing · apex host',

  // ── Workspaces ──────────────────────────────────────────────────────────────
  'Workspaces · Pinpoint': '工作区 · Pinpoint',
  'Workspaces': '工作区',
  'Delete this workspace? Its content will be removed.': '删除此工作区？其中的内容将被移除。',
  'Save': '保存',
  'Rename': '重命名',
  'Delete': '删除',

  // ── DateField (calendar popover) ────────────────────────────────────────────
  'yyyy/mm/dd': '年/月/日',
  'January': '一月',
  'February': '二月',
  'March': '三月',
  'April': '四月',
  'May': '五月',
  'June': '六月',
  'July': '七月',
  'August': '八月',
  'September': '九月',
  'October': '十月',
  'November': '十一月',
  'December': '十二月',
  'Clear': '清除',
  'Today': '今天',

  // ── Drawer ──────────────────────────────────────────────────────────────────
  'Done': '完成',
}
